/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-22 19:18:22
 */

import DeclareMaintenance from '../declareMaintenance';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import DeclareMaintenanceApi, { DeclareMaintenanceDOI } from '../api/declareMaintenanceApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import Input from 'src/types/iview/Input';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import DatePicker from 'src/types/iview/DatePicker';
import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import alertOperateMaintenanceModal from '../operateMaintenanceModal';
import EnumOperates from 'src/enums/enumOperates';
import alertAuditMaintenanceModal from '../auditMaintenanceModal';
import alertBatchAuditModal from '../batchAuditModal';

export default class DeclareMaintenanceService extends ListPageService {
    ctx: DeclareMaintenance;

    constructor(ctx: DeclareMaintenance) {
        super();
        this.ctx = ctx;
    }
    // 是否是申报
    get isDeclare() {
        return this.ctx.$route.name === 'maintenance-manage-declare-maintenance';
    }
    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '运维单号',
                field: 'ops_number',
                minWidth: 80,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: DeclareMaintenanceDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertAuditMaintenanceModal(EnumOperates.Detail.getName(), data.id, data.ops_number);
                                }}
                            >
                                {data.ops_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '运维站点',
                field: 'operational_site',
                minWidth: 140,
                cellRenderer(params) {
                    let data: DeclareMaintenanceDOI.RowDataI = params.data;
                    data.operational_site = data.operational_site||{data:[]}
                    return data.operational_site.data.map(i=>i.operational_site).join(',')
                },
            },
            {
                headerName: '申报类型',
                field: 'declare_type',
                minWidth: 100,
            },
            {
                headerName: '原因',
                field: 'cause',
                minWidth: 100,
            },
            {
                headerName: '审核状态',
                field: 'status',
                minWidth: 100,
                cellRenderer(params) {
                    let data: DeclareMaintenanceDOI.RowDataI = params.data;
                    return EnumMaintenanceAuditStatus.findId(data.status).getName();
                },
            },
            {
                headerName: '审核人',
                field: 'auditor',
                minWidth: 100,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        hide: !t.isDeclare,
                        disabled(params) {
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            return data.status !==EnumMaintenanceAuditStatus.UnAudit.getId();
                        },
                        async click(params) {
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            let res = await alertOperateMaintenanceModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        disabled(params) {
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            return data.status ===EnumMaintenanceAuditStatus.Audited.getId();
                        },
                        hide: !t.isDeclare,
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                    {
                        text: '审核',
                        hide: t.isDeclare,
                        disabled(params) {
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            return data.status !==EnumMaintenanceAuditStatus.UnAudit.getId();
                        },
                        async click(params) {
                            let data: DeclareMaintenanceDOI.RowDataI = params.data;
                            let res = await alertAuditMaintenanceModal(EnumOperates.Audit.getName(), data.id, data.ops_number);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '申报类型：',
                field: 'declare_type',
                props: { value: null, type: EnumEntity.DeclareType.getId() },
            },
            {
                component: CommonSelect,
                label: '审核状态：',
                field: 'status',
                props: { value: null, dataSource: EnumMaintenanceAuditStatus.getList() },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await DeclareMaintenanceApi.delete({ ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return this.isDeclare
            ? [
                  {
                      text: '新增',
                      async onClick() {
                          let res = await alertOperateMaintenanceModal(EnumOperates.Add.getName());
                          if (res) {
                              t.searchTable();
                          }
                      },
                  },
                  {
                      text: '删除',
                      type: 'info',
                      async onClick() {
                          let gridOptions: any = t.ctx.gridOptions;
                          let selectRows: DeclareMaintenanceDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                          if (selectRows.length === 0) {
                              return Toast.warning('请选择要操作的数据');
                          }
                          if(selectRows.map(data=> data.status ===EnumMaintenanceAuditStatus.Audited.getId())) {
                              return Toast.warning('已审核的数据不能删除');
                          }
                          let res = await Toast.confirm();
                          if (!res) {
                              return;
                          }
                          let ids: number[] = selectRows.map(item => item.id);
                          await t.delete(ids);
                      },
                  },
              ]
            : [
                  {
                      text: '批量审核',
                      async onClick() {
                          
                            let gridOptions: any = t.ctx.gridOptions;
                            let selectRows: DeclareMaintenanceDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                            if (selectRows.length === 0) {
                                return Toast.warning('请选择要操作的数据');
                            }
                            if(selectRows.some(data=> data.status === EnumMaintenanceAuditStatus.Audited.getId())) {
                                return Toast.warning('已审核的数据不能重复审核');
                            }
                            let ids: number[] = selectRows.map(item => item.id);
                            let res = await alertBatchAuditModal(ids, DeclareMaintenanceApi.batchAudit);
                          if (res) {
                              t.searchTable();
                          }
                      },
                  },
              ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<DeclareMaintenanceDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await DeclareMaintenanceApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
